import { msg } from '@lingui/core/macro';
import { defineScreen } from '@/shared/screen/define';

import { agreementFill, agreementSearch, hireNext, payrollBorrowerFill, payrollSimulationFill } from './simulation-hire.fill';
import { SIMULATION_READ } from './simulation.screen';

/** O Luy nos refinanciamentos e na compra (U56): convênio, tomador, simulação e avançar; contratos e ofertas são da pessoa. */
function renewalFills(prefix: string, options: { readonly agreement: boolean; readonly simulation: boolean }) {
  return {
    ...(options.agreement ? { searchAgreement: agreementSearch(prefix), agreement: agreementFill(prefix) } : {}),
    borrower: payrollBorrowerFill(prefix),
    ...(options.simulation ? { simulation: payrollSimulationFill(prefix) } : {}),
    next: hireNext(prefix),
  };
}
export const renewalFillsByKind = {
  publicRefinancing: renewalFills('simulation.publicRefinancing', { agreement: true, simulation: true }),
  privateRefinancing: renewalFills('simulation.privateRefinancing', { agreement: false, simulation: false }),
  inssRefinancing: renewalFills('simulation.inssRefinancing', { agreement: false, simulation: true }),
  debtPurchase: renewalFills('simulation.debtPurchase', { agreement: true, simulation: true }),
};

const access = { flag: { key: 'ENABLE_NEW_SIMULATION', equals: 1 } } as const;
export const PUBLIC_REFINANCING_PATH = '/ccb/contratar/consignado-publico/refinanciamento';
export const PRIVATE_REFINANCING_PATH = '/ccb/contratar/consignado-privado/refinanciamento';
export const INSS_REFINANCING_PATH = '/ccb/contratar/consignado-inss/refinanciamento';
export const DEBT_PURCHASE_PATH = '/ccb/contratar/consignado-publico/novo-compra-de-divida';
export const simulationPublicRefinancingScreen = defineScreen({
  id: 'simulation.publicRefinancing',
  path: PUBLIC_REFINANCING_PATH,
  title: msg`Refinanciamento de consignado público`,
  description: msg`Escolhe contratos, simula um refinanciamento e envia a oferta para análise.`,
  permission: SIMULATION_READ,
  access,
  place: { icon: 'file-text', parent: 'simulation.publicPayroll', flow: true },
  actions: Object.values(renewalFillsByKind.publicRefinancing),
});
export const simulationPrivateRefinancingScreen = defineScreen({
  id: 'simulation.privateRefinancing',
  path: PRIVATE_REFINANCING_PATH,
  title: msg`Refinanciamento de consignado privado`,
  description: msg`Escolhe um contrato do trabalhador, simula as ofertas e envia a proposta para análise.`,
  permission: SIMULATION_READ,
  access,
  place: { icon: 'file-text', parent: 'simulation.privatePayroll', flow: true },
  actions: Object.values(renewalFillsByKind.privateRefinancing),
});
export const simulationInssRefinancingScreen = defineScreen({
  id: 'simulation.inssRefinancing',
  path: INSS_REFINANCING_PATH,
  title: msg`Refinanciamento de consignado INSS`,
  description: msg`Escolhe os contratos do beneficiário e confere a simulação e o envio para análise.`,
  permission: SIMULATION_READ,
  access,
  place: { icon: 'file-text', parent: 'simulation.inssPayroll', flow: true },
  actions: Object.values(renewalFillsByKind.inssRefinancing),
});
export const simulationDebtPurchaseScreen = defineScreen({
  id: 'simulation.debtPurchase',
  path: DEBT_PURCHASE_PATH,
  title: msg`Compra de dívida`,
  description: msg`Seleciona ou informa contratos para compra de dívida, simula as ofertas e informa os pagamentos antes do envio para análise.`,
  permission: SIMULATION_READ,
  access,
  place: { icon: 'file-text', parent: 'simulation.publicPayroll', flow: true },
  actions: Object.values(renewalFillsByKind.debtPurchase),
});
export const renewalScreens = {
  publicRefinancing: simulationPublicRefinancingScreen,
  privateRefinancing: simulationPrivateRefinancingScreen,
  inssRefinancing: simulationInssRefinancingScreen,
  debtPurchase: simulationDebtPurchaseScreen,
};
